import { PropertyLedger } from "shared-ui-components/nodeGraphSystem/propertyLedger";
import { GenericPropertyComponent } from "./properties/genericNodePropertyComponent";
import { InputPropertyTabComponent } from "./properties/inputNodePropertyComponent";
import { TextureSourcePropertyTabComponent } from "./properties/textureSourceNodePropertyComponent";
import { DebugPropertyTabComponent } from "./properties/debugNodePropertyComponent";
import { TeleportOutPropertyTabComponent } from "./properties/teleportOutNodePropertyComponent";
import { MeshShapePropertyTabComponent } from "./properties/meshShapeNodePropertyComponent";
import { MeshSourcePropertyTabComponent } from "./properties/meshSourceNodePropertyComponent";

/**
 * Registers particle node blocks to the property ledger
 */
export const RegisterToPropertyTabManagers = () => {
    PropertyLedger.DefaultControl = GenericPropertyComponent;
    PropertyLedger.RegisteredControls["ParticleInputBlock"] = InputPropertyTabComponent;
    PropertyLedger.RegisteredControls["ParticleTextureSourceBlock"] = TextureSourcePropertyTabComponent;
    PropertyLedger.RegisteredControls["ParticleDebugBlock"] = DebugPropertyTabComponent;
    PropertyLedger.RegisteredControls["ParticleTeleportOutBlock"] = TeleportOutPropertyTabComponent;
    PropertyLedger.RegisteredControls["MeshShapeBlock"] = MeshShapePropertyTabComponent;

    PropertyLedger.RegisteredControls["MeshSourceBlock"] = MeshSourcePropertyTabComponent;
    PropertyLedger.RegisteredControls["CreateSolidParticleBlock"] = GenericPropertyComponent;
    PropertyLedger.RegisteredControls["MergeSolidParticlesBlock"] = GenericPropertyComponent;
    PropertyLedger.RegisteredControls["SolidParticleSystemBlock"] = GenericPropertyComponent;
    PropertyLedger.RegisteredControls["UpdateSolidParticlePositionBlock"] = GenericPropertyComponent;
    PropertyLedger.RegisteredControls["UpdateSolidParticleColorBlock"] = GenericPropertyComponent;
    PropertyLedger.RegisteredControls["UpdateSolidParticleScalingBlock"] = GenericPropertyComponent;
    PropertyLedger.RegisteredControls["UpdateSolidParticleRotationBlock"] = GenericPropertyComponent;
};
